import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as translationEnglish } from './i18n/en';
import { locale as translationRussian } from './i18n/ru';

@Component({
  selector: 'bfb-lead-queue-pannel',
  templateUrl: './lead-queue-pannel.component.html',
  styleUrls: ['./lead-queue-pannel.component.scss']
})
export class LeadQueuePannelComponent implements OnInit {

  currentLead: any;
  currentLeadLink = '';
  subscribed = false;
  showWarn = false;
  loggedIn = false;

  constructor(private dataService: DataService, private fuseTranslationLoader: FuseTranslationLoaderService) {
    this.fuseTranslationLoader.loadTranslations(translationEnglish, translationRussian);
    this.dataService.isLoggedIn.subscribe((loggedIn) => {
      this.loggedIn = loggedIn;
    });
    this.dataService.newLeadQueue.subscribe((res: any) => {
      console.log(res);
      this.subscribed = res.state === 'subscribed' ? true : false;
      if (res.lead) {
        this.showWarn = this.currentLead && this.currentLead.id === res.lead.id;
        this.currentLead = res.lead;
        if (this.currentLead.subtype === 'lp') {
          this.currentLeadLink = '/leads-legal/' + this.currentLead.id + '/details';
        } else if (this.currentLead.subtype === 'np') {
          this.currentLeadLink = '/leads/' + this.currentLead.id + '/details';
        }
      } else {
        this.currentLead = false;
        this.showWarn = false;
      }
    });
   }

  ngOnInit() {
  }

  getNextLead() {
    // console.log('emitToLeadQueue -> subscribe');
    this.dataService.emitToLeadQueue('subscribe');
  }

  unsubscribe() {
    // console.log('emitToLeadQueue -> unsubscribe');
    this.dataService.emitToLeadQueue('unsubscribe');
  }

}



// WEBPACK FOOTER //
// ./src/app/main/lead-queue-pannel/lead-queue-pannel.component.ts